import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "../api";
import { Seo } from "../components/Seo";
import { Button } from "../components/ui/button";

const input = "w-full h-12 rounded-md border border-input bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot-password", { email }); } catch {}
    setSent(true);
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="forgot-password-page">
      <Seo title="Forgot Password" description="Reset your DocGalaxy password." />
      <div className="bg-white border border-border rounded-2xl p-8 shadow-sm">
        <h1 className="font-display font-bold text-2xl">Reset password</h1>
        {sent ? (
          <p className="mt-4 text-sm bg-muted rounded-lg p-4" data-testid="forgot-sent-msg">
            If that email is registered, a reset link has been sent. Check your inbox.
          </p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
            <div>
              <label className="text-xs font-semibold" htmlFor="fp-email">Email</label>
              <input id="fp-email" type="email" required className={input} value={email}
                onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
            </div>
            <Button type="submit" className="w-full h-12 bg-primary" data-testid="forgot-submit-btn">Send reset link</Button>
          </form>
        )}
        <p className="mt-4 text-sm"><Link to="/login" className="text-primary" data-testid="back-to-login">Back to sign in</Link></p>
      </div>
    </div>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password });
      setMsg("Password updated. Redirecting to login...");
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) { setError(formatApiError(err)); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="reset-password-page">
      <Seo title="Set New Password" description="Set a new DocGalaxy password." />
      <div className="bg-white border border-border rounded-2xl p-8 shadow-sm">
        <h1 className="font-display font-bold text-2xl">Set new password</h1>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
          <div>
            <label className="text-xs font-semibold" htmlFor="rp-password">New password</label>
            <input id="rp-password" type="password" required minLength={6} className={input} value={password}
              onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" />
          </div>
          {msg && <p className="text-sm text-secondary" data-testid="reset-success">{msg}</p>}
          {error && <p className="text-sm text-destructive" data-testid="reset-error">{error}</p>}
          <Button type="submit" className="w-full h-12 bg-primary" data-testid="reset-submit-btn">Update password</Button>
        </form>
        <p className="mt-4 text-sm"><Link to="/login" className="text-primary">Back to sign in</Link></p>
      </div>
    </div>
  );
}
